exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Backtest-Header-___style__wrapper___PgLVy{display:flex;justify-content:space-between;align-items:flex-end;flex-wrap:wrap}.src-components-Backtest-Header-___style__wrapper___PgLVy h3{font-weight:600;margin:0;line-height:normal}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Backtest-Header-___style__wrapper___PgLVy"
};